import { render } from "./LiveVideoStreaming.vue?vue&type=template&id=bcfac0b0"
import script from "./LiveVideoStreaming.vue?vue&type=script&lang=js"
export * from "./LiveVideoStreaming.vue?vue&type=script&lang=js"
script.render = render

export default script